export default __webpack_public_path__ + "static/media/arrowUndoButton.9cdfb39c.svg";